module.exports = __webpack_public_path__ + "static/media/DSCF0123-32noiYgs.2a6d6da6.JPG";